import AxiosConfig from '../utils/AxiosConfig';
import { EMAIL_TEMPLATE_CATEGORY } from '../utils/Enums';

class EmailTemplateService {
  // Validar y normalizar la categoría del template
  validateCategory(category) {
    if (!category || typeof category !== 'string' || !category.trim()) {
      return null;
    }
    
    // Convertir a mayúsculas y buscar en los valores válidos
    const upperCategory = category.toUpperCase().trim();
    const validCategories = Object.values(EMAIL_TEMPLATE_CATEGORY);
    
    if (validCategories.includes(upperCategory)) {
      return upperCategory;
    }
    
    // Si no coincide, retornar null para que se valide antes de enviar
    console.warn('[EmailTemplateService] Invalid category:', category, 'Valid categories:', validCategories);
    return null;
  }
  // Obtener todos los templates personalizados
  async getTemplates(page = 1, pageSize = 10, searchTerm = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString()
      });
      
      if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
      }
      
      const response = await AxiosConfig.get(`/marketing/email-templates?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching email templates:', error);
      throw error;
    }
  }

  // Obtener un template específico por ID
  async getTemplateById(templateId) {
    try {
      const response = await AxiosConfig.get(`/marketing/email-templates/${templateId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching email template:', error);
      throw error;
    }
  }

  // Crear un nuevo template
  async createTemplate(templateData) {
    try {
      // Validar y normalizar la categoría
      const validatedCategory = this.validateCategory(templateData.category);
      
      if (!validatedCategory) {
        throw new Error(`Invalid category: ${templateData.category}. Valid categories are: ${Object.values(EMAIL_TEMPLATE_CATEGORY).join(', ')}`);
      }
      
      const validatedData = {
        ...templateData,
        category: validatedCategory
      };
      
      console.log('[EmailTemplateService] POST /marketing/email-templates - Request:', {
        name: validatedData.name,
        category: validatedData.category,
        subject: validatedData.subject
      });
      
      const response = await AxiosConfig.post('/marketing/email-templates', validatedData);
      return response.data;
    } catch (error) {
      console.error('[EmailTemplateService] POST /marketing/email-templates - Error:', error);
      console.error('[EmailTemplateService] POST /marketing/email-templates - Error Response:', error.response?.data);
      throw error;
    }
  }

  // Actualizar un template
  async updateTemplate(templateId, templateData) {
    try {
      // Validar y normalizar la categoría
      const validatedCategory = this.validateCategory(templateData.category);
      
      if (!validatedCategory) {
        throw new Error(`Invalid category: ${templateData.category}. Valid categories are: ${Object.values(EMAIL_TEMPLATE_CATEGORY).join(', ')}`);
      }
      
      const validatedData = {
        ...templateData,
        category: validatedCategory
      };
      
      console.log('[EmailTemplateService] PUT /marketing/email-templates/' + templateId + ' - Request:', {
        name: validatedData.name,
        category: validatedData.category,
        subject: validatedData.subject
      });
      
      const response = await AxiosConfig.put(`/marketing/email-templates/${templateId}`, validatedData);
      return response.data;
    } catch (error) {
      console.error('[EmailTemplateService] PUT /marketing/email-templates/' + templateId + ' - Error:', error);
      console.error('[EmailTemplateService] PUT /marketing/email-templates/' + templateId + ' - Error Response:', error.response?.data);
      throw error;
    }
  }

  // Eliminar un template
  async deleteTemplate(templateId) {
    try {
      const response = await AxiosConfig.delete(`/marketing/email-templates/${templateId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting email template:', error);
      throw error;
    }
  }
}

export default new EmailTemplateService();

